import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getTimelineInterval } from "../redux/selectors";
import Timeline from "./timeline";
const mapStateToProps = (state) => ({
    interval: getTimelineInterval(state)
});
const mapDispatchToProps = (dispatch) => ({
    onSetInterval: (interval) => dispatch(actionCreators.setTimelineInterval(interval))
});
export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
